import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useDialog } from '../contexts/DialogContext';

export const clasificaciones = {
  SIN_IDENTIFICAR: 'Sin identificar', PRODUCTO_NUEVO: 'Producto nuevo', VARIANTES_NUEVAS: 'Variantes nuevas',
  DATOS_INCOMPLETOS: 'Datos incompletos', DATOS_INVALIDOS: 'Datos invalidos', CONFLICTO: 'Conflicto'
};
export const motivosBloqueo = {
  ID_VACIO: 'ID vacio', ID_DUPLICADO: 'ID repetido en el archivo', ID_SIN_VINCULACION: 'ID sin vincular',
  DESTINO_REPETIDO: 'Varias filas apuntan a la misma variante', EQUIVALENCIA_PENDIENTE: 'Equivalencia de nombre o atributos pendiente',
  PRODUCTO_NUEVO_PENDIENTE: 'Producto nuevo pendiente de alta y vinculacion', VARIANTE_NUEVA_PENDIENTE: 'Variante nueva pendiente de alta',
  SIN_COINCIDENCIA: 'Sin coincidencia en el catalogo: revisar producto o variante', GRUPO_INCOMPLETO: 'Faltan variantes para completar el grupo de maderas',
  GRUPO_COSTOS_DIFERENTES: 'Las variantes del grupo de maderas tienen costos actuales diferentes',
  ID_INVALIDO: 'Formato del ID no reconocido', ATRIBUTOS_INCOMPLETOS: 'Faltan atributos para identificar el producto',
  GRUPO_CON_DESCRIPCIONES_DISTINTAS: 'El mismo grupo de IDs contiene distintos nombres', VARIANTE_AMBIGUA: 'Mas de una variante candidata',
  VINCULACION_PENDIENTE: 'Vinculacion pendiente', VINCULACION_SIN_DESTINOS: 'Vinculacion sin destinos',
  VINCULACION_INCOMPATIBLE: 'El CSV ya no coincide con el destino guardado para este ID',
  DESTINO_ELIMINADO: 'El producto o la variante ya no existe', ATRIBUTOS_CATALOGO_CAMBIARON: 'El catalogo cambio desde la vinculacion',
  MEDIDA_CONTRADICTORIA: 'La medida del nombre contradice la columna MEDIDAS', COSTO_INVALIDO: 'Costo no valido',
  COSTO_ACTUAL_INVALIDO: 'Costo actual no valido', NOMBRES_CONTRADICTORIOS: 'Distintos nombres propuestos para un mismo producto',
  TAPIZADO_INVALIDO: 'Tapizado no valido', OBSERVACION_SOFA_CAMBIO: 'Cambio de observaciones de medidas pendiente de revision',
  VARIANTE_SIN_COINCIDENCIA: 'No se encontro la combinacion de medida y tapizado en el catalogo',
  LUSTRE_INVALIDO: 'Lustre no admitido', VINCULACION_INVALIDA: 'Vinculacion invalida',
  DATOS_CON_HISTORIAL: 'Cambio descriptivo pendiente de revision: este producto tiene presupuestos o pedidos asociados'
};
const importe = valor => valor === null || valor === undefined ? '-' : Number(valor).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });

export function descargarReporte(reporte, nombre) {
  const url = URL.createObjectURL(new Blob([reporte], { type: 'text/csv;charset=utf-8' }));
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombre;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

const CatalogoBloqueosPanel = ({ preview, recurso, busqueda = '', onResuelto, onOcupado, soloLectura = false }) => {
  const { showConfirm } = useDialog();
  const [clave, setClave] = useState('');
  const [propuesta, setPropuesta] = useState(null);
  const [modelo, setModelo] = useState('');
  const [seleccion, setSeleccion] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [reporteCaso, setReporteCaso] = useState('');
  const casos = (preview.casosBloqueados || []).filter(caso => `${caso.clave} ${caso.descripcion} ${caso.filas.map(fila => fila.idCliente).join(' ')}`
    .toLowerCase().includes(busqueda.toLowerCase().trim()));
  const caso = casos.find(caso => caso.clave === clave);
  const esNuevo = propuesta?.accion === 'CREAR_PRODUCTO';
  const filasAlta = caso?.filas.filter(fila => propuesta?.ids.includes(fila.idCliente)) || [];

  useEffect(() => {
    if (onOcupado) onOcupado(guardando || cargando);
    return () => { if (onOcupado) onOcupado(false); };
  }, [guardando, cargando, onOcupado]);

  useEffect(() => {
    let vigente = true;
    setError('');
    setPropuesta(null);
    setReporteCaso('');
    setSeleccion([]);
    if (!caso || soloLectura) { setCargando(false); return () => { vigente = false; }; }
    setCargando(true);
    api.get(`/catalogo/importacion/${recurso}/casos/${preview.previewId}`, { params: { claveCaso: caso.clave } })
      .then(respuesta => {
        if (!vigente) return;
        setPropuesta(respuesta.propuesta);
        setModelo(respuesta.propuesta?.modelo || caso.descripcion);
        setSeleccion(respuesta.propuesta?.ids || []);
        setReporteCaso(respuesta.reporteBloqueadas);
      })
      .catch(problema => { if (vigente) setError(problema.message || String(problema)); })
      .finally(() => { if (vigente) setCargando(false); });
    return () => { vigente = false; };
  }, [caso, preview.previewId, preview.firmaResolucion, recurso, soloLectura]);

  const dejarPendiente = () => {
    setClave('');
    setMensaje('El caso queda pendiente en el reporte.');
  };
  const guardar = async () => {
    if (!propuesta?.accion || !seleccion.length || guardando) return;
    const confirmado = await showConfirm(esNuevo
      ? `Crear ${propuesta.tipo} ${modelo} con ${seleccion.length} variantes y vincular sus IDs del cliente. Se usaran los costos del CSV.`
      : `Agregar ${seleccion.length} variantes a ${propuesta.tipo} ${propuesta.modelo} y vincular sus IDs. No se modificaran las variantes existentes.`,
    { title: esNuevo ? 'Crear producto nuevo' : 'Agregar variantes nuevas', confirmLabel: 'Confirmar alta' });
    if (!confirmado) return;
    setGuardando(true);
    setError('');
    try {
      const respuesta = await api.post(`/catalogo/importacion/${recurso}/resolver`, {
        previewId: preview.previewId, firmaResolucion: preview.firmaResolucion, claveCaso: caso.clave,
        accion: propuesta.accion, simplificado: true, confirmar: true, modelo, tipo: propuesta.tipo,
        catalogoId: propuesta.catalogoId, filas: seleccion.map(idCliente => ({ idCliente }))
      });
      setClave('');
      setMensaje(`${respuesta.resolucion.filas} variantes creadas y vinculadas.`);
      onResuelto(respuesta);
    } catch (problema) { setError(problema.message || String(problema)); }
    finally { setGuardando(false); }
  };

  return <section className="bloqueos-panel" aria-label="Casos bloqueados">
    <div className="bloqueos-barra"><strong>{preview.casosBloqueados?.length || 0} casos / {preview.resumen.bloqueadas} filas</strong></div>
    {mensaje && <p role="status" className="bloqueos-exito">{mensaje}</p>}
    <div className="importacion-tabla-scroll"><table className="importacion-tabla bloqueos-lista">
      <thead><tr><th>Producto</th><th>Variantes</th><th>Accion</th></tr></thead>
      <tbody>{casos.map(valor => {
        const puedeRevisar = valor.filas.some(fila => !['DATOS_INVALIDOS', 'DATOS_INCOMPLETOS', 'CONFLICTO'].includes(fila.clasificacion));
        return <tr key={valor.clave}>
          <td><strong>{valor.tipo} / {valor.descripcion}</strong><small>{valor.clave}</small></td><td>{valor.cantidad}</td>
          <td>{!soloLectura && puedeRevisar ? <button type="button" className="btn-actualizacion-global" disabled={cargando || guardando}
            onClick={() => { setClave(valor.clave); setMensaje(''); }}>Revisar alta</button> : <span>Pendiente en CSV</span>}</td>
        </tr>;
      })}{!casos.length && <tr><td colSpan={3}>No hay casos para esta busqueda.</td></tr>}</tbody>
    </table></div>
    {caso && !soloLectura && <section className="bloqueos-alta" aria-label="Confirmacion de alta">
      {cargando && <p role="status">Comprobando IDs del grupo...</p>}
      {error && <p role="alert" className="importacion-error">{error}</p>}
      {propuesta && <>
        {propuesta.accion ? <>
          <h3>{esNuevo ? '¿Es un producto nuevo?' : `¿Agregar variantes a ${propuesta.tipo} / ${propuesta.modelo}?`}</h3>
          {esNuevo && <label className="bloqueos-modelo">Modelo<input maxLength={120} value={modelo} disabled={guardando} onChange={event => setModelo(event.target.value)} /></label>}
          <div className="importacion-tabla-scroll"><table className="importacion-tabla bloqueos-variantes">
            <thead><tr><th><input type="checkbox" aria-label="Seleccionar todas las variantes" disabled={guardando}
              checked={seleccion.length === filasAlta.length} onChange={event => setSeleccion(event.target.checked ? filasAlta.map(fila => fila.idCliente) : [])} /></th>
              <th>ID cliente</th><th>Madera</th><th>Lustre</th><th>Tapizado</th>{['RESPALDO', 'SOFA'].includes(preview.categoria) && <th>Medida</th>}<th>Costo</th></tr></thead>
            <tbody>{filasAlta.map(fila => <tr key={fila.renglon}>
              <td><input type="checkbox" aria-label={`Seleccionar ${fila.idCliente}`} disabled={guardando} checked={seleccion.includes(fila.idCliente)}
                onChange={event => setSeleccion(actual => event.target.checked ? [...actual, fila.idCliente] : actual.filter(id => id !== fila.idCliente))} /></td>
              <td>{fila.idCliente}</td><td>{fila.madera}</td><td>{fila.lustre}</td><td>{fila.tapizado}</td>
              {['RESPALDO', 'SOFA'].includes(preview.categoria) && <td>{fila.medidas}</td>}<td>{importe(fila.costoNuevo)}</td>
            </tr>)}</tbody>
          </table></div>
          <div className="bloqueos-guardar"><span>{seleccion.length} variantes seleccionadas</span>
            <button type="button" className="btn-actualizacion-global" onClick={guardar} disabled={guardando || !seleccion.length || seleccion.length > 200 || (esNuevo && !modelo.trim())}>
              {guardando ? 'Guardando...' : esNuevo ? 'Si, crear producto' : 'Confirmar nuevas variantes'}
            </button><button type="button" className="btn-limpiar-filtros" disabled={guardando} onClick={dejarPendiente}>No, dejar pendiente</button>
          </div>
        </> : <p>{propuesta.motivo}</p>}
        {reporteCaso && <button type="button" className="btn-actualizacion-global" disabled={guardando}
          onClick={() => descargarReporte(reporteCaso, `${recurso}-${caso.clave}-bloqueadas.csv`)}>Descargar caso CSV</button>}
        {!propuesta.accion && <button type="button" className="btn-limpiar-filtros" onClick={dejarPendiente}>Cerrar</button>}
      </>}
    </section>}
  </section>;
};

export default CatalogoBloqueosPanel;